import { useCashier } from '../contexts/CashierProvider';
import ForbiddenAccessPage from '../pages/ForbiddenAccessPage';
import { useTranslation } from 'react-i18next';

interface CashierGuardProps {
    children: React.ReactNode;
    display?: boolean;
}

export default function CashierGuard({ children, display = false }: CashierGuardProps) {
    const auth = useCashier();
    const { t } = useTranslation();

    if (auth.loading) {
        return null; // Or a loading spinner
    }
    if (!auth.isCashier) {
        return (
            display ? (
                <ForbiddenAccessPage
                    message={t('guard.cashier.forbidden_message', { defaultValue: 'Only cashier users can access this section.' })}
                />
            ) : null
        );
    }

    return <>{children}</>;
}
